import React from 'react';

const Section = props => {
    return (
        <div style={
            {
                marginTop: 10,
                marginLeft: 15,
                marginBottom: 25,
                backgroundColor: 'rgb(250, 250, 250)',
                borderLeft: '1px solid rgb(2, 136, 209)',
                padding: '10px 20px 10px 10px'
            }
        }>
            {props.children}
        </div>
    );
};

export default Section;


// WEBPACK FOOTER //
// ./src/components/restaurants/upsell/Section.js